import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { BehaviorSubject, Observable } from "rxjs";
import { APP_IDLE_COUNTDOWN_SECS, APP_IDLE_LIMIT_SECS } from "../common/constants";
import { TimeoutModalComponent } from "../components/timeout-modal/timeout-modal.component";
import { LoggerService } from "./logger.service";

@Injectable({
  providedIn: "root",
})
export class IdleTimerService {
  private countDown$: BehaviorSubject<string> = new BehaviorSubject(null);
  idleState = "Not started.";
  timedOut = false;
  lastPing?: Date = null;
  countDownText = "";

  constructor(
    public idle: Idle,
    private keepalive: Keepalive,
    private modalService: NgbModal,
    private logger: LoggerService,
    private msalService: MsalService
  ) {}

  getCountDownObs(): Observable<string> {
    return this.countDown$.asObservable();
  }

  setCountDownObs(txt: string): void {
    this.countDown$.next(txt);
  }

  initIdleTimeout(): void {
    this.logger.info("initIdleTimeoutService");
    // sets an this.idle timeout
    this.idle.setIdle(APP_IDLE_LIMIT_SECS);
    this.idle.setTimeout(APP_IDLE_COUNTDOWN_SECS);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = "No longer idle.";
      this.logger.debug(this.idleState, 'ui');
      this.reset();
    });

    this.idle.onTimeout.subscribe(() => {
      this.idleState = "Timed out!";
      this.timedOut = true;
      this.logger.debug(this.idleState, 'ui');
      this.logout();
    });

    this.idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
      this.logger.debug(this.idleState, 'ui');
      if (!this.modalService.hasOpenModals()) {
        this.open();
      }
    });

    this.idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = "You will time out in " + countdown + " seconds!";
      this.setCountDownObs(this.idleState);
      this.logger.debug(this.idleState, 'ui');
    });

    // sets the ping interval to 15 seconds
    this.keepalive.interval(15);

    this.keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
  }

  open() {
    const modalRef = this.modalService.open(TimeoutModalComponent, {
      centered: true,
      size: "sm",
    });
    modalRef.componentInstance.idleState = this.idleState;
    modalRef.result.then((action) => {
      switch (action) {
        case "logout":
          this.logout();
          break;
        case "stay":
          this.logger.debug("stay", 'ui');
          break;
        case "close":
          this.logger.debug("close", 'ui');
          break;
        default:
          break;
      }
    });
  }

  logout(): void {
    this.msalService.logout();
  }

}
